export const AUTH_KEY = process.env.NEXT_PUBLIC_AUTH_KEY ?? "_gj_emp_auth_2";
export const REMEBER_KEY =
  process.env.NEXT_PUBLIC_REMEBER_KEY ?? "_gj_emp_auth_2_rem";
export const AUTH_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_AUTH_PUBLIC_KEY ?? "_gj_pa_2";
export const EXPIRES_IN = "1d";
export const BANNER_STATUS_KEY =
  process.env.NEXT_PUBLIC_BANNER_STATUS_KEY ?? "_gj_emp_banner_popup_2";
